import React from 'react';

interface SubscriptionConfirmationModalProps {
	isOpen: boolean;
	isLoading: boolean;
	onClose: () => void;
	onConfirm: () => void;
	title: string;
	message: string;
	confirmText?: string;
	cancelText?: string;
}

const SubscriptionConfirmationModal: React.FC<
	SubscriptionConfirmationModalProps
> = ({
	isOpen,
	isLoading,
	onClose,
	onConfirm,
	title,
	message,
	confirmText = 'Confirm',
	cancelText = 'Cancel',
}) => {
	if (!isOpen) {
		return null;
	}

	return (
		<div className="fixed inset-0 z-[1000] flex items-center justify-center bg-black bg-opacity-50">
			<div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
				<h2 className="text-lg font-semibold mb-4">{title}</h2>
				<p className="mb-4">{message}</p>
				<div className="flex justify-end gap-4">
					<button
						disabled={isLoading}
						onClick={onClose}
						className={`px-4 py-2 rounded-md border border-gray-300 hover:bg-gray-100 transition 
                ${
									isLoading
										? 'opacity-50 cursor-not-allowed'
										: 'active:scale-95'
								}`}
					>
						{cancelText}
					</button>
					<button
						disabled={isLoading}
						onClick={onConfirm}
						className={`px-4 py-2 rounded-md bg-purpleBrand-500 hover:bg-purpleBrand-600 text-white transition 
              ${
								isLoading ? 'opacity-50 cursor-not-allowed' : 'active:scale-95'
							}`}
					>
						{confirmText}
					</button>
				</div>
			</div>
		</div>
	);
};

export default SubscriptionConfirmationModal;
